import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages";
import GenesisShop from "./pages/GenesisShop";
import HyundaiModel from "./pages/HyundaiModel";

const App = (props) => {
  return (
    <Router>
      <Switch>
        <Route path="/genesis-shop" component={GenesisShop} />
        <Route path="/hyundai-3d-model" component={HyundaiModel} />
        <Route path="/" render={() => <Home images={props.images} />} />
      </Switch>
    </Router>
  );
};

export default App;
